import $axios from "../../api";

const module = "hr/attendance"

const state = () => ({
  isLoading: false,
  isErrors: "",
  page: 1,
  isSuccess: false,
  list: null,
  detail: null,
  successDataHris: [],
  successDataFinger: [],
  failedDataHris: [],
  failedDataFinger: [],
  previewData: [],
  attendanceStatusList: [],
});

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  ASSIGN_ERRORS(state, payload) {
    state.isErrors = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_IS_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_DETAIL(state, payload) {
    state.detail = payload;
  },
  SET_SUCCESS_DATA_HRIS(state, payload) {
    state.successDataHris = payload;
  },
  SET_FAILED_DATA_HRIS(state, payload) {
    state.failedDataHris = payload;
  },
  SET_SUCCESS_DATA_FINGER(state, payload) {
    state.successDataFinger = payload;
  },
  SET_FAILED_DATA_FINGER(state, payload) {
    state.failedDataFinger = payload;
  },
  SET_PREVIEW_DATA(state, payload) {
    state.previewData = payload;
  },
  SET_ATTENDANCE_STATUS(state, payload) {
    state.attendanceStatusList = payload;
  },
};

const getters = {
  successDataHris: state => state.successDataHris,
  failedDataHris: state => state.failedDataHris,
  successDataFinger: state => state.successDataFinger,
  failedDataFinger: state => state.failedDataFinger,
  previewData: state => state.previewData,
};

const actions = {
  getList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `${module}/convert/list?page=${state.page}&view=${rootState.Main.view
          }${payload || ""}`
        )
        .then((res) => {
          commit("SET_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          localStorage.removeItem('filterData');
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getDetail({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`${module}/convert/view${payload}`)
        .then((res) => {
          commit("SET_DETAIL", res.data);
          commit("SET_LOADING", false);
          resolve(res.data);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error);
        });
    });
  },
  // payload: { file, month, year } — periode wajib, server memakainya untuk
  // memvalidasi & memulihkan tanggal tiap baris (App\Support\Hr\HrisImportPeriod).
  importHrisData({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('file', payload.file);
      formData.append('period_month', payload.month);
      formData.append('period_year', payload.year);

      $axios
        .post(`${module}/convert/import-hris`, formData)
        .then((res) => {
          if (res.data.status === 'success') {

            commit("SET_SUCCESS_DATA_HRIS", res.data.data || []);
            commit("SET_FAILED_DATA_HRIS", res.data.failed || []);
            dispatch("Main/globalSuccessSweetAlert",
              res.data.count_corrected > 0
                ? `Import selesai — ${res.data.count_corrected} tanggal dipulihkan, periksa sebelum Save.`
                : 'Data imported successfully.',
              { root: true, });
            commit("SET_LOADING", false);
            resolve(res);
          } else {
            commit("ASSIGN_ERRORS", { message: res.data.message });
            dispatch("Main/globalSweetAlert",
              res.data.message,
              { root: true, });
            commit("SET_LOADING", false);
            reject(new Error(res.data.message));
          }
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          commit("ASSIGN_ERRORS", error.response ? error.response.data : { message: 'Unknown error occurred' });
          dispatch("Main/globalSweetAlert",
            error.response ? error.response.data.message : 'An unknown error occurred.',
            { root: true, });
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  downloadHrisFail({ commit, dispatch }) {
    commit('SET_LOADING', true);

    return new Promise((resolve, reject) => {
      $axios.get(`${module}/convert/import-hris/failed`, {
        responseType: 'blob',
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;

          const contentDisposition = response.headers['content-disposition'];
          let fileName = 'failed_hris.xlsx';
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
            if (fileNameMatch && fileNameMatch.length === 2) fileName = fileNameMatch[1];
          }

          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          commit('SET_LOADING', false);
          resolve();
        })
        .catch((error) => {
          commit('SET_LOADING', false);
          dispatch('Main/globalSweetAlert', error.response, { root: true });
          reject(error);
        });
    });
  },
  saveHris({ commit, dispatch }) {
    commit("SET_LOADING", true);
    commit("SET_IS_SUCCESS", false);
    return new Promise((resolve, reject) => {
      $axios.post(`${module}/convert/import-hris/save`)
        .then((res) => {
          // Log untuk debugging
          if (res.data.status === 'success') {
            dispatch("Main/globalSuccessSweetAlert", 'Data imported successfully.', { root: true });
            commit("SET_LOADING", false);
            commit("SET_IS_SUCCESS", true);
            resolve(res);
          } else {
            commit("ASSIGN_ERRORS", { message: res.data.message });
            dispatch("Main/globalSweetAlert", res.data.message, { root: true });
            commit("SET_LOADING", false);
            commit("SET_IS_SUCCESS", false);
            reject(new Error(res.data.message));
          }
        })
        .catch((error) => {
          console.error('Request Error:', error);

          commit("SET_LOADING", false);
          commit("SET_IS_SUCCESS", false);
          commit("ASSIGN_ERRORS", error.response ? error.response.data : { message: 'Unknown error occurred' });
          dispatch("Main/globalSweetAlert", error.response ? error.response.data.message : 'An unknown error occurred.', { root: true });
          reject(error);
        });
    });
  },
  importFingerData({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('file', payload);

      $axios
        .post(`${module}/convert/import-finger`, formData)
        .then((res) => {
          if (res.data.status === 'success') {

            commit("SET_SUCCESS_DATA_FINGER", res.data.data || []);
            commit("SET_FAILED_DATA_FINGER", res.data.failed || []);
            dispatch("Main/globalSuccessSweetAlert",
              'Data imported successfully.',
              { root: true, });
            commit("SET_LOADING", false);
            resolve(res);
          } else {
            commit("ASSIGN_ERRORS", { message: res.data.message });
            dispatch("Main/globalSweetAlert",
              res.data.message,
              { root: true, });
            commit("SET_LOADING", false);
            reject(new Error(res.data.message));
          }
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          commit("ASSIGN_ERRORS", error.response ? error.response.data : { message: 'Unknown error occurred' });
          dispatch("Main/globalSweetAlert",
            error.response ? error.response.data.message : 'An unknown error occurred.',
            { root: true, });
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  downloadFingerFail({ commit, dispatch }) {
    commit('SET_LOADING', true);
    return new Promise((resolve, reject) => {
      $axios.get(`${module}/convert/import-finger/failed`, {
        responseType: 'blob',
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;

          const contentDisposition = response.headers['content-disposition'];
          let fileName = 'failed_finger.xlsx';
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
            if (fileNameMatch && fileNameMatch.length === 2) fileName = fileNameMatch[1];
          }

          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          commit('SET_LOADING', false);
          resolve();
        })
        .catch((error) => {
          commit('SET_LOADING', false);
          dispatch('Main/globalSweetAlert', error.response, { root: true });
          reject(error);
        });
    });
  },
  saveFinger({ commit, dispatch }) {
    commit("SET_LOADING", true);
    commit("SET_IS_SUCCESS", false);
    return new Promise((resolve, reject) => {
      $axios.post(`${module}/convert/import-finger/save`)
        .then((res) => {
          // Log untuk debugging

          if (res.data.status === 'success') {
            dispatch("Main/globalSuccessSweetAlert", 'Data imported successfully.', { root: true });
            commit("SET_LOADING", false);
            commit("SET_IS_SUCCESS", true);
            resolve(res);
          } else {
            commit("ASSIGN_ERRORS", { message: res.data.message });
            dispatch("Main/globalSweetAlert", res.data.message, { root: true });
            commit("SET_LOADING", false);
            commit("SET_IS_SUCCESS", false);
            reject(new Error(res.data.message));
          }
        })
        .catch((error) => {
          console.error('Request Error:', error);

          commit("SET_LOADING", false);
          commit("SET_IS_SUCCESS", false);
          commit("ASSIGN_ERRORS", error.response ? error.response.data : { message: 'Unknown error occurred' });
          dispatch("Main/globalSweetAlert", error.response ? error.response.data.message : 'An unknown error occurred.', { root: true });
          reject(error);
        });
    });
  },
  exportIndividualAttendance({ commit, dispatch }, { id, year, month }) {
    commit('SET_LOADING', true);
    return new Promise((resolve, reject) => {
      const url = `${module}/convert/export/individual?id=${id}&date=${year}-${month}-1`;
      $axios.get(url, {
        responseType: 'blob',
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;

          const contentDisposition = response.headers['content-disposition'];
          let fileName = `export-${id}-${year}-${month}-attendance.xlsx`;
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
            if (fileNameMatch && fileNameMatch.length === 2) fileName = fileNameMatch[1];
          }

          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          commit('SET_LOADING', false);
          resolve();
        })
        .catch((error) => {
          commit('SET_LOADING', false);
          dispatch('Main/globalSweetAlert', error.response, { root: true });
          reject(error);
        });
    });
  },
  exportConvertExcel({ commit, dispatch }, payload) {
    commit('SET_LOADING', true);
    return new Promise((resolve, reject) => {
      const url = `${module}/convert/export/convert${payload}`;
      $axios.get(url, {
        responseType: 'blob',
        // Eksplisit no-timeout — export bulanan multi-employee bisa 20s+, default
        // axios sebenarnya sudah 0, tapi global instance bisa di-override.
        timeout: 0,
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;

          const contentDisposition = response.headers['content-disposition'];
          // Fallback dinamis: derive yymmdd dari payload `?date=YYYY-MM-DD...` kalau ada,
          // selain itu pakai today's date. Hanya dipakai bila header tidak ada — normalnya
          // backend (Maatwebsite) sudah set Content-Disposition dengan filename benar.
          const dateMatch = (payload || '').match(/date=(\d{4})-(\d{1,2})-(\d{1,2})/);
          let fallbackDate;
          if (dateMatch) {
            const [, yyyy, mm, dd] = dateMatch;
            fallbackDate = yyyy.slice(2) + mm.padStart(2, '0') + dd.padStart(2, '0');
          } else {
            const now = new Date();
            fallbackDate = String(now.getFullYear()).slice(2)
              + String(now.getMonth() + 1).padStart(2, '0')
              + String(now.getDate()).padStart(2, '0');
          }
          let fileName = `export-attendance-${fallbackDate}.xlsx`;
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
            if (fileNameMatch && fileNameMatch.length === 2) fileName = fileNameMatch[1];
          }

          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          commit('SET_LOADING', false);
          resolve();
        })
        .catch((error) => {
          commit('SET_LOADING', false);
          dispatch('Main/globalSweetAlert', error.response, { root: true });
          reject(error);
        });
    });
  },
  exportKerajinanExcel({ commit, dispatch }, payload) {
    commit('SET_LOADING', true);
    return new Promise((resolve, reject) => {
      const url = `${module}/convert/export/kerajinan${payload}`;
      $axios.get(url, {
        responseType: 'blob',
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;

          const contentDisposition = response.headers['content-disposition'];
          let fileName = `export-payroll-kerajinan.xlsx`;
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
            if (fileNameMatch && fileNameMatch.length === 2) fileName = fileNameMatch[1];
          }

          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          commit('SET_LOADING', false);
          resolve();
        })
        .catch((error) => {
          commit('SET_LOADING', false);
          dispatch('Main/globalSweetAlert', error.response, { root: true });
          reject(error);
        });
    });
  },
  removeCache({ commit, dispatch }, payload) {
    // commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${module}/convert/remove/cache/${payload}`)
        .then((res) => {
          // commit("SET_LOADING", false);

          if (payload == 'hris') {
            commit("SET_SUCCESS_DATA_HRIS", []);
            commit("SET_FAILED_DATA_HRIS", []);

          } else if (payload == 'finger') {
            commit("SET_SUCCESS_DATA_FINGER", []);
            commit("SET_FAILED_DATA_FINGER", []);

          } else {
            commit("SET_SUCCESS_DATA_HRIS", []);
            commit("SET_FAILED_DATA_HRIS", []);
            commit("SET_SUCCESS_DATA_FINGER", []);
            commit("SET_FAILED_DATA_FINGER", []);
          }

          if (res.data.status === 'success') {
            resolve(res);
          } else {
            commit("ASSIGN_ERRORS", { message: res.data.message });
            reject(new Error(res.data.message));
          }
        })
        .catch((error) => {
          // commit("SET_LOADING", false);
          const errorMsg = error.response ? error.response.data.message : 'An unknown error occurred.';
          commit("ASSIGN_ERRORS", error.response ? error.response.data : { message: errorMsg });
          reject(error);
        });
    });
  },
  deleteAttend({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      $axios
        .post(`${module}/convert/delete`, payload)
        .then((response) => {
          dispatch("Main/globalSuccessSweetAlert", 'Data deleted.', { root: true });
          resolve(response);
        })
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error);
        });
    });
  },
  deleteAttendPeriode({ commit, dispatch }, payload) {
    commit("SET_IS_SUCCESS", false);
    commit('SET_LOADING', true);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${module}/convert/delete-periode`, payload)
        .then((response) => {
          commit("SET_IS_SUCCESS", true);
          commit('SET_LOADING', false);
          resolve(response);
        })
        .catch((error) => {
          commit("SET_IS_SUCCESS", false);
          commit('SET_LOADING', false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
  getPreview({ commit, dispatch }, payload) {
    commit('SET_LOADING', true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`${module}/convert/preview-delete`, { params: payload })
        .then((res) => {
          if (res.data.status === 'success') {
            commit('SET_PREVIEW_DATA', res.data.data);
          }
          commit('SET_LOADING', false);
          resolve();
        })
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          commit('SET_LOADING', false);
          reject(error);
        });
    });
  },
  getAttendanceStatus({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `${module}/status/list?page=${state.page}&view=${rootState.Main.view
          }${payload || ""}`
        )
        .then((res) => {
          commit("SET_ATTENDANCE_STATUS", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          localStorage.removeItem('filterData');
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  exportExcelStatus({ commit, state, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `${module}/status/exportexcel?page=${state.page}${payload ? payload : ""
          }`,
          { responseType: "blob" }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;

          const contentDisposition = response.headers['content-disposition'];
          let fileName = `Export_Data_Status_Attendance_${new Date().toISOString().slice(0, 10)}.xlsx`;
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
            if (fileNameMatch && fileNameMatch.length === 2) fileName = fileNameMatch[1];
          }

          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          commit('SET_LOADING', false);
          resolve();

          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch('Main/globalSweetAlert', error.response, { root: true })
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};

